import { Navigate, useLocation } from "react-router-dom";
import { getUser } from "@api/useAuth";
import { getDefaultRouteForUser } from "@utils";
import { getAccessToken, clearAuthCookies } from "@utils/cookies";

export default function ProtectedRoute({ children, allowedRoles = [], skipStatusCheck = false }) {
  const location = useLocation();
  const accessToken = getAccessToken();
  const user = getUser();

  if (!accessToken) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!user) {
    clearAuthCookies();
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Redirect non-active users to account-status page
  if (!skipStatusCheck && user.status && user.status !== "active") {
    return <Navigate to="/account-status" replace />;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    return <Navigate to={getDefaultRouteForUser(user)} replace />;
  }

  return children;
}
